import { render, staticRenderFns } from "./textBeforeTitle.vue?vue&type=template&id=626e7832&scoped=true"
import script from "./textBeforeTitle.vue?vue&type=script&lang=js"
export * from "./textBeforeTitle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "626e7832",
  null
  
)

export default component.exports